/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function syncScopedFormControls(form, oldId, newId) {
    var scope = form.closest('quick-add-product') || form.closest('.product-upsell__holder') || form.parentElement || document;
    scope.querySelectorAll('[form]').forEach(function(control) {
      if (control.getAttribute('form') === oldId) {
        control.setAttribute('form', newId);
      }
    });
  }

  function dedupeProductFormIds() {
    var seen = Object.create(null);
    document.querySelectorAll('form[id^="ProductForm--"], form[id^="ProductFormUpsell--"]').forEach(function(form) {
      var originalId = form.getAttribute('id');
      if (!originalId) return;
      seen[originalId] = (seen[originalId] || 0) + 1;
      if (seen[originalId] === 1) return;

      var nextId = originalId + '-vireo-' + seen[originalId];
      var suffix = seen[originalId];
      while (document.getElementById(nextId)) {
        suffix += 1;
        nextId = originalId + '-vireo-' + suffix;
      }

      form.setAttribute('id', nextId);
      syncScopedFormControls(form, originalId, nextId);
    });
  }

  var dedupeQueued = false;
  function queueProductFormDedupe() {
    if (dedupeQueued) return;
    dedupeQueued = true;
    requestAnimationFrame(function() {
      dedupeQueued = false;
      dedupeProductFormIds();
    });
  }

  document.addEventListener('DOMContentLoaded', queueProductFormDedupe);
  window.addEventListener('load', queueProductFormDedupe);
  document.addEventListener('theme:recently-viewed:loaded', queueProductFormDedupe, true);

  if (document.documentElement) {
    new MutationObserver(queueProductFormDedupe).observe(document.documentElement, { childList: true, subtree: true });
  }

  function upgradeSameDomainHttpLinks() {
    document.querySelectorAll('a[href^="http://www.vireoshop.de"]').forEach(function(link) {
      link.setAttribute('href', link.getAttribute('href').replace('http://www.vireoshop.de', 'https://www.vireoshop.de'));
    });
  }

  var linkUpgradeQueued = false;
  function queueSameDomainLinkUpgrade() {
    if (linkUpgradeQueued) return;
    linkUpgradeQueued = true;
    requestAnimationFrame(function() {
      linkUpgradeQueued = false;
      upgradeSameDomainHttpLinks();
    });
  }

  document.addEventListener('DOMContentLoaded', queueSameDomainLinkUpgrade);
  window.addEventListener('load', queueSameDomainLinkUpgrade);

  if (document.documentElement) {
    new MutationObserver(queueSameDomainLinkUpgrade).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Shopify's unrestricted storefront search currently returns the full catalogue
  // for unmatched terms. Scope submitted customer terms to product titles so an
  // unmatched search correctly shows no results, while the field stays human-readable.
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.search-form')) return;

    var queryInput = form.querySelector('input[type="search"][name="q"]');
    if (!queryInput) return;

    var customerTerm = queryInput.value.trim();
    if (customerTerm && customerTerm.indexOf('title:') !== 0) {
      queryInput.value = 'title:' + customerTerm;
    }
  });



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
